export const CONTAINER = 'CONTAINER';
export const ROW = 'ROW';
export const COLUMN = 'COLUMN';
export const ELEMENT = 'ELEMENT';



// WEBPACK FOOTER //
// ./app/header-builder/element-categories.js